import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  ObjectUpdatePageSchema,
  ObjectUpdateSchema,
  type ObjectUpdate,
  type ObjectUpdatePage,
  type UpdateAnchorType,
} from "@/lib/data/schemas/updates/ObjectUpdateSchema";
import type { APIResponse } from "@/lib/types";

export type RetrieveObjectUpdatesParams = {
  anchorObjectType: UpdateAnchorType;
  anchorObjectId: string;
  limit?: number;
  cursor?: string;
};

export const createObjectUpdate = async (data: {
  anchorObjectType: UpdateAnchorType;
  anchorObjectId: string;
  message: string;
}): Promise<APIResponse<ObjectUpdate>> => {
  const response = await authenticatedFastApiAxiosInstance.post<
    APIResponse<ObjectUpdate>
  >("updates/v2", data);
  return {
    ...response.data,
    data: ObjectUpdateSchema.parse(response.data.data),
  };
};

export const editObjectUpdate = async ({
  id,
  message,
}: {
  id: string;
  message: string;
}): Promise<APIResponse<ObjectUpdate>> => {
  const response = await authenticatedFastApiAxiosInstance.patch<
    APIResponse<ObjectUpdate>
  >(`updates/v2/${encodeURIComponent(id)}`, { message });
  return {
    ...response.data,
    data: ObjectUpdateSchema.parse(response.data.data),
  };
};

export const deleteObjectUpdate = async (
  id: string,
): Promise<APIResponse<ObjectUpdate>> => {
  const response = await authenticatedFastApiAxiosInstance.delete<
    APIResponse<ObjectUpdate>
  >(`updates/v2/${encodeURIComponent(id)}`);
  return {
    ...response.data,
    data: ObjectUpdateSchema.parse(response.data.data),
  };
};

export const retrieveObjectUpdates = async (
  params: RetrieveObjectUpdatesParams,
): Promise<APIResponse<ObjectUpdatePage>> => {
  const response = await authenticatedFastApiAxiosInstance.get<
    APIResponse<ObjectUpdatePage>
  >("updates/v2", { params });

  return {
    ...response.data,
    data: ObjectUpdatePageSchema.parse(response.data.data),
  };
};
